import { render, staticRenderFns } from "./SendQuoteFeesPromoAndDiscount.vue?vue&type=template&id=94bcab08&"
import script from "./SendQuoteFeesPromoAndDiscount.vue?vue&type=script&lang=js&"
export * from "./SendQuoteFeesPromoAndDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports